import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import Vision from '../components/Vision';
import Advantages from '../components/Advantages';
import Testimonials from '../components/Testimonials';
import Partnership from '../components/Partnership';
import Contact from '../components/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Products />
      <Vision />
      <Advantages />
      <Testimonials />
      <Partnership />
      <Contact />
    </>
  );
};

export default HomePage;
